import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TermsAndConditions from "./TermsandConditions";
import '../../styles/scrollbar.css';
import { useTranslation } from 'react-i18next';
import bgvideo from "../Assets/Xianhe New Assets/mainpage/mainpage-landingbg.mp4";

const SignUpPage = () => {
  const { t, i18n } = useTranslation();
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [dobTime, setDobTime] = useState("");
  const [chineseDob, setChineseDob] = useState("");
  const [chineseDobTime, setChineseDobTime] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [country, setCountry] = useState();
  const [countries, setCountries] = useState([]);
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [reference, setReference] = useState("");
  const [isDobTimeUnknown, setIsDobTimeUnknown] = useState(false);
  const [countryCode, setCountryCode] = useState("+1"); // default to US
  const [mobileExists, setMobileExists] = useState(false);
  const [mobileExistsMessage, setMobileExistsMessage] = useState("");
  const [emailExistsMessage, setEmailExistsMessage] = useState("");
  const [interests, setInterests] = useState("");
  const [interestOptions, setInterestOptions] = useState([]);
  const [selectedInterestUids, setSelectedInterestUids] = useState([]);

  const [ID, setID] = useState("");
  const [emailExists, setEmailExists] = useState(false);
  const navigate = useNavigate();

  const [dobManual, setDobManual] = useState("");
  const [dobManualActive, setDobManualActive] = useState(false);
  const [chineseDobManual, setChineseDobManual] = useState("");
  const [chineseDobManualActive, setChineseDobManualActive] = useState(false);

  // Add these new state variables
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isCreatingAccount, setIsCreatingAccount] = useState(false);
  const [birthCalendarMode, setBirthCalendarMode] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalIssues, setErrorModalIssues] = useState([]);


  // Time fields (12-hour) + AM/PM
  const [dobHour, setDobHour] = useState("");
  const [dobMinute, setDobMinute] = useState("");
  const [dobAmPm, setDobAmPm] = useState("AM");

  const [chineseDobHour, setChineseDobHour] = useState("");
  const [chineseDobMinute, setChineseDobMinute] = useState("");
  const [chineseDobAmPm, setChineseDobAmPm] = useState("AM");

  const [personalID, setPersonalID] = useState("");
  // Add these new state variables after the existing state declarations
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");


  function parseManualDate(val) {
    // Accepts DD-MM-YYYY or DD/MM/YYYY or any separators; stores as YYYY-MM-DD
    let clean = val.replace(/[^0-9]/g, "");
    if (clean.length !== 8) return null;
    const day = clean.slice(0, 2);
    const month = clean.slice(2, 4);
    const year = clean.slice(4, 8);
    if (
      Number(day) < 1 ||
      Number(day) > 31 ||
      Number(month) < 1 ||
      Number(month) > 12 ||
      Number(year) < 1900 ||
      Number(year) > 2100
    )
      return null;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  // Build 24h time string from 12h parts (HH:MM:00)
  function to24h(hour, minute, ampm) {
    if (!hour || !minute) return "";
    let h = parseInt(hour, 10);
    let m = parseInt(minute, 10);
    if (isNaN(h) || isNaN(m)) return "";
    if (ampm === "PM" && h !== 12) h += 12;
    if (ampm === "AM" && h === 12) h = 0;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
  }

  // When user edits DOB time inputs, mirror to Chinese time and recalc Chinese date
  function syncTimeFromDob(hour, minute, ampm) {
    setDobHour(hour);
    setDobMinute(minute);
    setDobAmPm(ampm);
    setChineseDobHour(hour);
    setChineseDobMinute(minute);
    setChineseDobAmPm(ampm);

    const t = to24h(hour, minute, ampm);
    setDobTime(t);
    setChineseDobTime(t);

    if (!isDobTimeUnknown && dob) {
      handleFetchData(false); // Gregorian -> Chinese
    }
  }

  // When user edits Chinese DOB time inputs, mirror to DOB time and recalc Gregorian date
  function syncTimeFromChinese(hour, minute, ampm) {
    setChineseDobHour(hour);
    setChineseDobMinute(minute);
    setChineseDobAmPm(ampm);
    setDobHour(hour);
    setDobMinute(minute);
    setDobAmPm(ampm);

    const t = to24h(hour, minute, ampm);
    setChineseDobTime(t);
    setDobTime(t);

    if (!isDobTimeUnknown && chineseDob) {
      handleFetchData(true); // Chinese -> Gregorian
    }
  }

  const [isChecked, setIsChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Extract promocode from URL if present
  const { promocode } = useParams();

  useEffect(() => {
    if (promocode) {
      setReference(promocode);
    }
  }, [promocode]);

  const handleBirthCalendarModeSelect = (mode) => {
    if (mode === birthCalendarMode) {
      setBirthCalendarMode("");
      return;
    }
    setBirthCalendarMode(mode);
  };

  // Add this helper function above your component return
  function validateMobileByCountry(mobile, countryCode) {
    const cleaned = mobile.replace(/\D/g, "");
    let errorMsg = "";
    let valid = true;
    switch (countryCode) {
      case "+63": // Philippines
        valid = /^([89]\d{9})$/.test(cleaned);
        if (!valid) errorMsg = "Philippines mobile numbers must be 10 digits and start with 9 or 8";
        break;
      case "+65": // Singapore
        valid = /^([89]\d{7})$/.test(cleaned);
        if (!valid) errorMsg = "Singapore mobile numbers must be 8 digits and start with 8 or 9";
        break;
      case "+60": // Malaysia
        valid = /^(1\d{8,9})$/.test(cleaned);
        if (!valid) errorMsg = "Malaysia mobile numbers must be 9 or 10 digits and start with 1";
        break;
      case "+86": // China
        valid = /^(1\d{10})$/.test(cleaned);
        if (!valid) errorMsg = "China mobile numbers must be 11 digits and start with 1";
        break;
      case "+62": // Indonesia
        valid = /^(8\d{9,10})$/.test(cleaned);
        if (!valid) errorMsg = "Indonesia mobile numbers must be 10 or 11 digits and start with 8";
        break;
      case "+855": // Cambodia
        valid = /^([16789]\d{7,8})$/.test(cleaned);
        if (!valid) errorMsg = "Cambodia mobile numbers must be 8 or 9 digits and start with 1, 6, 7, 8, or 9";
        break;
      case "+852": // Hong Kong
        valid = /^([4-9]\d{7})$/.test(cleaned);
        if (!valid) errorMsg = "Hong Kong mobile numbers must be 8 digits and start with 4-9";
        break;
      default:
        valid = true;
        errorMsg = "";
    }
    return { valid, errorMsg };
  }

  // Add a new state for mobile validation error
  const [mobileFormatError, setMobileFormatError] = useState("");
  // Add a new state for email format validation error
  const [emailFormatError, setEmailFormatError] = useState("");



  const isValidPassword = (password) => {
    // Require at least 6 chars, 1 upper, 1 lower, 1 number, 1 special
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\[\]{};':"\\|,.<>\/?`~\-]).{6,}$/;
    return regex.test(password);
  };

  // Re-checked fresh (not from state) so browser autofill that skips onBlur/onChange can't bypass it
  const checkEmailExists = async (emailToCheck) => {
    try {
      const res = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/user/IsEmailExist?email=${encodeURIComponent(emailToCheck)}`
      );
      const data = await res.json();
      return data.successful === true;
    } catch (err) {
      console.error("Error checking email:", err);
      return false;
    }
  };

  const checkMobileExists = async (formattedMobile) => {
    try {
      const res = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/user/IsMobileExist?mobile=${encodeURIComponent(formattedMobile)}`
      );
      const data = await res.json();
      return data.successful === true;
    } catch (err) {
      console.error("Error checking mobile:", err);
      return false;
    }
  };

  const handleConfirm = async () => {
    setIsCreatingAccount(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailFormatOk = emailRegex.test(email);
    const emailAlreadyUsed = emailFormatOk ? await checkEmailExists(email) : false;
    setEmailExists(emailAlreadyUsed);

    const mobileFormatResult = countryCode && mobile.trim()
      ? validateMobileByCountry(mobile, countryCode)
      : { valid: true, errorMsg: "" };
    const mobileAlreadyUsed = mobile.trim() && mobileFormatResult.valid
      ? await checkMobileExists(`${countryCode} ${mobile}`)
      : false;
    setMobileExists(mobileAlreadyUsed);

    const issues = [];
    const nameOk = firstName.trim() && lastName.trim();
    if (!nameOk) issues.push(t('signUpPage.issueNames'));
    const genderOk = !!gender;
    if (!genderOk) issues.push(t('signUpPage.issueGender'));
    const dobOk = !!dob && !!chineseDob && (isDobTimeUnknown || (dobTime && chineseDobTime));
    if (!dobOk) issues.push(t('signUpPage.issueBirthDetails'));
    const emailOk = emailFormatOk && !emailAlreadyUsed;
    if (!emailOk) issues.push(emailAlreadyUsed ? t('signUpPage.issueEmailUsed') : t('signUpPage.issueValidEmail'));
    const countryOk = !!country;
    if (!countryOk) issues.push(t('signUpPage.issueCountry'));
    const mobileOk = mobile.trim().length > 0 && mobileFormatResult.valid && !mobileAlreadyUsed;
    if (!mobileOk) issues.push(mobileAlreadyUsed ? t('signUpPage.issueMobileUsed') : t('signUpPage.issueMobile'));
    const pwdOk = isPasswordMatch && isValidPassword(password);
    if (!pwdOk) issues.push(t('signUpPage.issuePassword'));
    const termsOk = isChecked;
    if (!termsOk) issues.push(t('signUpPage.issueTerms'));

    if (issues.length > 0) {
      setErrorModalIssues(issues);
      setShowErrorModal(true);
      setIsCreatingAccount(false);
      return;
    }

    const dobandtime = `${dob} ${dobTime}`;
    const cdob = `${chineseDob} ${chineseDobTime}`;

    // Prepare country and dial code for the API. Keep backward compatibility if country is a string.
    const countryName = country ? (typeof country === "string" ? country : country.country || country.DESC_ENG) : "";
    const dialCode = country ? (typeof country === "string" ? countryCode : country.dial_code || country.Dial_Code || countryCode) : countryCode;

    // Map translation keys back to English values for the API
    const interestMapping = {
      [t('interest.topics.jobSeeking')]: 'Job Seeking',
      [t('interest.topics.findingPartner')]: 'Finding a Partner',
      [t('interest.topics.financialGrowth')]: 'Financial Growth & Wealth',
      [t('interest.topics.entrepreneurship')]: 'Entrepreneurship & Side Hustles',
      [t('interest.topics.careerAdvancement')]: 'Career Advancement',
      [t('interest.topics.skillDevelopment')]: 'Skill Development & Learning',
      [t('interest.topics.healthFitness')]: 'Health & Fitness',
      [t('interest.topics.mentalWellness')]: 'Mental Wellness & Mindfulness',
      [t('interest.topics.personalGrowth')]: 'Personal Growth & Wisdom',
      [t('interest.topics.relationships')]: 'Relationships & Communication',
      [t('interest.topics.loveFamily')]: 'Love & Family',
      [t('interest.topics.networking')]: 'Networking & Social Impact',
      [t('interest.topics.lifestyle')]: 'Lifestyle & Happiness',
      [t('interest.topics.retirement')]: 'Retirement & Long-Term Planning'
    };

    // Convert interests back to English
    const englishInterests = interests
      .split(',')
      .map(interest => interestMapping[interest.trim()] || interest.trim())
      .filter(Boolean)
      .join(', ');

    const body = {
      ID: "0",
      RefNo: reference,
      FName: firstName,
      LName: lastName,
      DateOfBirth: dobandtime,
      ChineseDateOfBirth: cdob,
      Gender: gender,
      Age: age,
      MobileNo: dialCode ? `${dialCode} ${mobile}` : mobile,
      country: countryName,
      dial_code: dialCode,
      Email: email,
      Password: password,
      Search_Interest: englishInterests, // Use English version
      InterestUid: selectedInterestUids.join(","),
    };

    console.log("Submitting sign-up with body:", body);

    try {
      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/user/ProfileSaveUpdate?token = xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error("Request failed with status " + response.status);
      }
      const result = await response.json();
      console.log("Sign-up response:", result);
      
      if (result) {
        // Show success modal
        setShowSuccessModal(true);
        
        // After 2 seconds, automatically log in the user
        setTimeout(async () => {
          await performAutoLogin();
        }, 2000);
      }
    } catch (error) {
      console.error("Sign-up error:", error);
      setIsCreatingAccount(false);
      // You might want to show an error message here
    }
  };

  // Add this new function to handle automatic login
  const performAutoLogin = async () => {
    try {
      const loginUrl = "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin";
      const loginData = {
        UserName: email,
        Password: password,
        Token: {
          AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
        },
      };

      const loginResponse = await fetch(loginUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      });

      const loginResult = await loginResponse.json();

      if (loginResult && loginResult.ID !== null && loginResult.ID !== undefined) {
        // Store user data in localStorage (do NOT store plaintext passwords)
        localStorage.setItem("username", loginResult.username || email);
        localStorage.setItem("userID", loginResult.ID);
        localStorage.setItem("name", loginResult.FullName || `${firstName} ${lastName}`);
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("roletype", loginResult.Role || "Member");

        // Fetch user coins
        try {
          const coinsResponse = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${loginResult.ID}`
          );
          if (coinsResponse.ok) {
            const coinsData = await coinsResponse.json();
            localStorage.setItem("coins", coinsData[0]?.COINS || "0");
          }
        } catch (error) {
          console.error("Error fetching coins:", error);
          localStorage.setItem("coins", "0");
        }

        // Fetch commission coins
        try {
          const commissionResponse = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${loginResult.ID}`
          );
          if (commissionResponse.ok) {
            const commissionData = await commissionResponse.json();
            localStorage.setItem("comcoins", commissionData[0]?.COINS || "0");
          }
        } catch (error) {
          console.error("Error fetching commission coins:", error);
          localStorage.setItem("comcoins", "0");
        }

        // Use window.location.href for a clean page reload with navigation
        window.location.href = "/chart";
      } else {
        console.error("Auto-login failed:", loginResult);
        setShowSuccessModal(false);
        setIsCreatingAccount(false);
        navigate("/login");
      }
    } catch (error) {
      console.error("Auto-login error:", error);
      setShowSuccessModal(false);
      setIsCreatingAccount(false);
      navigate("/login");
    }
  };

  const isPasswordMatch = password === rePassword;

  const handleKeyPress = (event, nextStep) => {
    if (event.key === "Enter") {
      nextStep();
    }
  };

  const calculateAge = (dateOfBirth) => {
    const birthDate = new Date(dateOfBirth);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    setAge(age);
  };

  // Always keep age synced to the resolved Gregorian DOB
  useEffect(() => {
    if (dob) calculateAge(dob);
    else setAge("");
  }, [dob]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/country/getcountry"
        );
        const data = await response.json();

        // Check if data is an array; if not, handle appropriately
        if (Array.isArray(data)) {
          setCountries(data);
        } else {
          console.error("Unexpected API response:", data);
          setCountries([]); // Fallback to an empty array
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        setCountries([]); // Fallback to an empty array
      }
    };

    fetchCountries();
  }, []);

  const handleFetchData = async (isChinese = false) => {
  const baseUrl = "https://xianhefairy.com/LotusFairy_API/api/member";
  const endpoint = isChinese ? "GetDOB_By_Lunar" : "GetChineseDOB";
  const date = isChinese ? chineseDob : dob;
  const time = isChinese ? chineseDobTime : dobTime;

  if (!date) return;

  // Extract date components
  const dateParts = date.split("-");
  const cYear = dateParts[0];
  const cMonth = dateParts[1];
  const cDay = dateParts[2];
  const formattedTime = time ? time.slice(0, 5) : "00:00";

  console.log("Calling API with:", {
    endpoint,
    cYear,
    cMonth,
    cDay,
    formattedTime,
  });
  
  try {
    const response = await fetch(
      `${baseUrl}/${endpoint}?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${formattedTime}`
    );
    const data = await response.json();

    console.log("API response:", data);

    if (Array.isArray(data) && data.length > 0) {
      const responseData = data[0];
      if (isChinese) {
        // If input is Chinese DOB, set Gregorian DOB
        if (responseData.DOB) {
          const gregorianDate = responseData.DOB.split("T")[0];
          setDob(gregorianDate);
          console.log("Gregorian DOB set from Chinese DOB:", gregorianDate);
        }
      } else {
        // If input is Gregorian DOB, set Chinese DOB
        // IMPORTANT: Store as text display, not as a date for date picker
        if (
          responseData.CN_LUNAR_YEAR_NO &&
          responseData.CN_LUNAR_MONTH_NO &&
          responseData.CN_LUNAR_DAY_NO
        ) {
          // Format for display only - this is LUNAR calendar, not Gregorian
          const lunarDay = responseData.CN_LUNAR_DAY_NO.toString().padStart(2, "0");
          const lunarMonth = responseData.CN_LUNAR_MONTH_NO.toString().padStart(2, "0");
          const lunarYear = responseData.CN_LUNAR_YEAR_NO.toString().padStart(4, "0");
          
          // Store in format DD-MM-YYYY for DISPLAY purposes
          const chineseDateDisplay = `${lunarDay}-${lunarMonth}-${lunarYear}`;
          
          // But store in YYYY-MM-DD format for backend
          const chineseDateForBackend = `${lunarYear}-${lunarMonth}-${lunarDay}`;
          
          setChineseDob(chineseDateForBackend);
          setChineseDobManual(chineseDateDisplay); // Show in manual input
          setChineseDobManualActive(true); // Force manual mode for Chinese date
          
          console.log("Chinese DOB (lunar) set:", chineseDateForBackend, "Display:", chineseDateDisplay);
        }
      }
    } else {
      console.error("Unexpected data format or empty response:", data);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  // const handleFetchData = async (isChinese = false) => {
  //   const baseUrl = "https://xianhefairy.com/LotusFairy_API/api/member";
  //   const endpoint = isChinese ? "GetDOB_By_Lunar" : "GetChineseDOB";
  //   const date = isChinese ? chineseDob : dob;
  //   const time = isChinese ? chineseDobTime : dobTime;

  //   if (!date) return;

  //   // Extract date components
  //   const dateParts = date.split("-");
  //   const cYear = dateParts[0];
  //   const cMonth = dateParts[1];
  //   const cDay = dateParts[2];
  //   const formattedTime = time ? time.slice(0, 5) : "00:00";

  //   // Log for debugging
  //   console.log("Calling API with:", {
  //     endpoint,
  //     cYear,
  //     cMonth,
  //     cDay,
  //     formattedTime,
  //   });
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/${endpoint}?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${formattedTime}`
  //     );
  //     const data = await response.json();

  //     console.log("API response:", data);

  //     if (Array.isArray(data) && data.length > 0) {
  //       const responseData = data[0];
  //       if (isChinese) {
  //         // If input is Chinese DOB, set Gregorian DOB
  //         if (responseData.DOB) {
  //           const gregorianDate = responseData.DOB.split("T")[0];
  //           setDob(gregorianDate); // This triggers age sync via useEffect
  //           console.log("Gregorian DOB set from Chinese DOB:", gregorianDate);
  //         }
  //       } else {
  //         // If input is Gregorian DOB, set Chinese DOB using CN_LUNAR_* fields
  //         if (responseData.LUNAR_DATE) {
  //           setChineseDob(responseData.LUNAR_DATE);
  //           console.log("Chinese DOB set from Gregorian DOB:", responseData.LUNAR_DATE);
  //         }
  //         // if (
  //         //   responseData.CN_LUNAR_YEAR_NO &&
  //         //   responseData.CN_LUNAR_MONTH_NO &&
  //         //   responseData.CN_LUNAR_DAY_NO
  //         // ) {
  //         //   const chineseDate = `${responseData.CN_LUNAR_YEAR_NO.toString().padStart(
  //         //     4,
  //         //     "0"
  //         //   )}-${responseData.CN_LUNAR_MONTH_NO.toString().padStart(
  //         //     2,
  //         //     "0"
  //         //   )}-${responseData.CN_LUNAR_DAY_NO.toString().padStart(2, "0")}`;
  //         //   setChineseDob(chineseDate);
  //         //   console.log("Chinese DOB set from Gregorian DOB:", chineseDate);
  //         // }
  //       }
  //     } else {
  //       console.error("Unexpected data format or empty response:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  useEffect(() => {
    if (isDobTimeUnknown) {
      if (dob) {
        handleFetchData(false); // Fetch Chinese DOB based on DOB
      } else if (chineseDob) {
        handleFetchData(true); // Fetch DOB based on Chinese DOB
      }
    }
  }, [isDobTimeUnknown, dob, chineseDob]);

  // Backfill HH/MM/AMPM display if dobTime or chineseDobTime changes programmatically
  useEffect(() => {
    if (!dobTime) return;
    const [hStr, m] = dobTime.split(":");
    let h = parseInt(hStr, 10);
    let ampm = h >= 12 ? "PM" : "AM";
    if (h === 0) h = 12;
    else if (h > 12) h -= 12;
    setDobHour(String(h));
    setDobMinute(m);
    setDobAmPm(ampm);
    // Mirror to Chinese UI too
    setChineseDobHour(String(h));
    setChineseDobMinute(m);
    setChineseDobAmPm(ampm);
  }, [dobTime]);

  useEffect(() => {
    if (!chineseDobTime) return;
    const [hStr, m] = chineseDobTime.split(":");
    let h = parseInt(hStr, 10);
    let ampm = h >= 12 ? "PM" : "AM";
    if (h === 0) h = 12;
    else if (h > 12) h -= 12;
    setChineseDobHour(String(h));
    setChineseDobMinute(m);
    setChineseDobAmPm(ampm);
    // Mirror to DOB UI too
    setDobHour(String(h));
    setDobMinute(m);
    setDobAmPm(ampm);
  }, [chineseDobTime]);

  // Fetch interests based on language
  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const langId = localStorage.getItem('languageId') || '2224'; // Default to English
        const response = await fetch(
          `https://xianhefairy.com/Lotusfairy_api/api/SiteContent/GetListInterest?LangId=${langId}`
        );
        const data = await response.json();
        if (Array.isArray(data)) {
          setInterestOptions(data);
        }
      } catch (error) {
        console.error('Error fetching interests:', error);
      }
    };
    fetchInterests();
  }, [i18n.language]); // Refetch when language changes

  const handleInterestChange = (uid, description) => {
    const isSelected = selectedInterestUids.includes(uid);
    
    if (isSelected) {
      // Remove from selection
      setSelectedInterestUids(prev => prev.filter(id => id !== uid));
      const current = interests
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .filter(item => item !== description);
      setInterests(current.join(", "));
    } else {
      // Add to selection
      setSelectedInterestUids(prev => [...prev, uid]);
      const current = interests
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      setInterests([...current, description].join(", "));
    }
  };

  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "black",
    color: "#DFBD69",
    overflowY: "auto",
    position: "relative",
    transition: "all 0.5s ease-in-out",
    padding: "40px 16px",
  };

  const backgroundVideoStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    opacity: 0.75,
    zIndex: 0,
    pointerEvents: "none",
  };

  const backgroundOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    zIndex: 0,
    pointerEvents: "none",
  };

  

  const inputStyle = {
    padding: "10px",
    width: "300px",
    fontSize: "16px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #DFBD69",
    outline: "1px solid #DFBD69",
    backgroundColor: "black",
    color: "#DFBD69",
    height: "50px", // <-- Add this line
  };

  const DOBstyle = {
    padding: "10px",
    width: "100%",
    fontSize: "16px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #DFBD69",
    outline: "1px solid #DFBD69",
    backgroundColor: "black",
    color: "#DFBD69",
  };
  const DOBstyleAMPM = {
    padding: "10px",
    //width: "100%",
    fontSize: "16px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #DFBD69",
    outline: "1px solid #DFBD69",
    backgroundColor: "black",
    color: "#DFBD69",
  };

  const readOnlyDOBStyle = {
    ...inputStyle,
    width: "min(100%, 300px)",
    color: "#888",
    backgroundColor: "#111",
    border: "1px solid #666",
    outline: "1px solid #666",
    cursor: "not-allowed",
  };

  const inputStyleCountries = {
    padding: "10px",
    width: "300px",
    fontSize: "16px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #DFBD69",
    outline: "1px solid #DFBD69",
    backgroundColor: "black",
    color: "#DFBD69",
    height: "50px", // <-- Add this line
  };

  const passwordInputContainerStyle = {
    position: "relative",
    display: "inline-block",
    width: "300px",
    margin: "10px 0",
  };

  const eyeIconStyle = {
    position: "absolute",
    top: "50%",
    right: "10px",
    transform: "translateY(-50%)",
    cursor: "pointer",
    fontSize: "18px",
    color: "#DFBD69",
  };

  const buttonStyle = {
    margin: "10px",
    padding: "5px 60px",
    fontSize: "16px",
    cursor: "pointer",
    border: "2px solid #DFBD69", // fixed this line
    borderRadius: "25px",
    backgroundColor: "black",
    fontWeight: "bold",
    color: "#DFBD69",
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#333",
    color: "#666",
    border: "2px solid #555",
    cursor: "not-allowed",
  };

  const checkboxLabelStyle = {
    fontSize: "14px",
    cursor: "pointer",
  };

  

  const inputContainerStyle = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "15px", // Adjusted margin for better spacing
    alignItems: "flex-start", // Ensures all inputs and labels are aligned to the left
  };

  const checkboxStyle = {
    marginRight: "10px", // Adjusted margin to add some space around the checkbox
  };

  const labelInput = {
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "bold",
  };

  const dobContainerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    justifyContent: "space-between",
    width: "100%",
    // backgroundColor:'red',
    alignItems: "center",
  };

  const formWrapperStyle = {
    width: "100%",
    maxWidth: "720px",
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    position: "relative",
    zIndex: 1,
  };

  const sectionStyle = {
    width: "100%",
    background: "rgba(255,255,255,0.03)",
    border: "1px solid #2b2b2b",
    borderRadius: "12px",
    padding: "16px",
  };

  const sectionHeaderStyle = {
    marginTop: 0,
    marginBottom: "8px",
    fontSize: "18px",
  };

  // Compute a stable select key for country dropdown (prefer ISO2, then ID)
  let selectedKey = "";
  if (country) {
    if (typeof country === "string") {
      const found = countries.find((c) => c.DESC_ENG === country || c.country === country);
      if (found) selectedKey = found.ISO2 || found.iso2 || found.ID || found.country || "";
    } else {
      selectedKey = country.iso2 || country.ISO2 || country.ID || country.country || "";
    }
  }

  return (
    <div style={containerStyle}>
      <video
        autoPlay
        loop
        playsInline
        preload="auto"
        defaultMuted
        muted
        style={backgroundVideoStyle}
        aria-hidden="true"
      >
        <source src={bgvideo} type="video/mp4" />
      </video>
      <div style={backgroundOverlayStyle} aria-hidden="true" />

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <div
            style={{
              backgroundColor: "#151517",
              border: "2px solid #DFBD69",
              borderRadius: "15px",
              padding: "40px",
              textAlign: "center",
              maxWidth: "500px",
              width: "90%",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
            }}
          >
            <h2
              style={{
                color: "#DFBD69",
                marginBottom: "15px",
                fontSize: "24px",
                fontWeight: "bold",
              }}
            >
              {t('signUpPage.thankYou')}
            </h2>
            <p
              style={{
                color: "#DFBD69",
                fontSize: "18px",
                lineHeight: "1.5",
                marginBottom: "20px",
              }}
            >
              {t('signUpPage.accountCreated')}
              <br />
              {t('signUpPage.loggingIn')}
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                color: "#DFBD69",
              }}
            >
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  border: "3px solid #DFBD69",
                  borderTop: "3px solid transparent",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              ></div>
              <span>{t('signUpPage.pleaseWait')}</span>
            </div>
          </div>
        </div>
      )}
      <div style={formWrapperStyle}>
        {/* Back button to Main */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <button
            onClick={() => navigate("/main")}
            style={{ ...buttonStyle, padding: "6px 16px" }}
          >
            {t('signUpPage.backToMain')}
          </button>
        </div>
        <div style={{ textAlign: "center" }}>
          <h2 style={{ margin: 0 }}>{t('signUpPage.newSignUp')}</h2>
          <p style={{ marginTop: 4, color: "#bfa865" }}>{t('signUpPage.createAccount')}</p>
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionHeaderStyle}>{t('signUpPage.basicInformation')}</h3>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 220 }}>
              <input
                type="text"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  if (e.target.value.trim() === "") {
                    setFirstNameError(t('signUpPage.firstNameRequired'));
                  } else {
                    setFirstNameError("");
                  }
                }}
                onBlur={() => {
                  if (firstName.trim() === "") {
                    setFirstNameError(t('signUpPage.firstNameRequired'));
                  }
                }}
                placeholder={t('signUpPage.firstName')}
                style={{ ...inputStyle, width: "100%" }}
              />
              {firstNameError && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "4px", marginBottom: 0 }}>
                  {firstNameError}
                </p>
              )}
            </div>
            <div style={{ flex: 1, minWidth: 220 }}>
              <input
                type="text"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  if (e.target.value.trim() === "") {
                    setLastNameError(t('signUpPage.lastNameRequired'));
                  } else {
                    setLastNameError("");
                  }
                }}
                onBlur={() => {
                  if (lastName.trim() === "") {
                    setLastNameError(t('signUpPage.lastNameRequired'));
                  }
                }}
                placeholder={t('signUpPage.lastName')}
                style={{ ...inputStyle, width: "100%" }}
              />
              {lastNameError && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "4px", marginBottom: 0 }}>
                  {lastNameError}
                </p>
              )}
            </div>
          </div>
          <div style={{ marginTop: 8 }}>
            <label style={{ marginRight: 8 }}>{t('signUpPage.gender')}:</label>
            <button
              onClick={() => setGender("Male")}
              aria-pressed={gender === "Male"}
              style={{
                ...buttonStyle,
                padding: "6px 16px",
                backgroundColor: gender === "Male" ? "#DFBD69" : "black",
                color: gender === "Male" ? "black" : "#DFBD69",
                border: "2px solid #DFBD69",
                fontWeight: "bold",
                transition: "background 0.2s, color 0.2s"
              }}
            >
              {t('account.male')}
            </button>
            <button
              onClick={() => setGender("Female")}
              aria-pressed={gender === "Female"}
              style={{
                ...buttonStyle,
                padding: "6px 16px",
                backgroundColor: gender === "Female" ? "#DFBD69" : "black",
                color: gender === "Female" ? "black" : "#DFBD69",
                border: "2px solid #DFBD69",
                fontWeight: "bold",
                transition: "background 0.2s, color 0.2s"
              }}
            >
              {t('account.female')}
            </button>
          </div>
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionHeaderStyle}>{t('signUpPage.birthDetails')}</h3>
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
              <span style={{ color: "#bfa865", fontSize: 14 }}>
                {birthCalendarMode
                  ? `Selected input calendar: ${birthCalendarMode === "gregorian" ? "Gregorian" : "Lunar"} (click X to choose again)`
                  : "Choose input calendar"}
              </span>
              {!birthCalendarMode ? (
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button
                    type="button"
                    onClick={() => handleBirthCalendarModeSelect("gregorian")}
                    style={{
                      ...buttonStyle,
                      margin: 0,
                      padding: "6px 16px",
                      borderRadius: "10px",
                    }}
                  >
                    Gregorian
                  </button>
                  <button
                    type="button"
                    onClick={() => handleBirthCalendarModeSelect("lunar")}
                    style={{
                      ...buttonStyle,
                      margin: 0,
                      padding: "6px 16px",
                      borderRadius: "10px",
                    }}
                  >
                    Lunar
                  </button>
                </div>
              ) : (
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                  <button
                    type="button"
                    onClick={() => handleBirthCalendarModeSelect(birthCalendarMode)}
                    aria-label="Return to calendar chooser"
                    style={{
                      ...buttonStyle,
                      margin: 0,
                      padding: "6px 16px",
                      borderRadius: "10px",
                      backgroundColor: "#DFBD69",
                      color: "black",
                      cursor: "pointer",
                    }}
                  >
                    {birthCalendarMode === "gregorian" ? "Gregorian" : "Lunar"}
                    <span style={{ marginLeft: 8, fontWeight: "bold" }}>X</span>
                  </button>
                </div>
              )}
            </div>

            {birthCalendarMode === "gregorian" && (
            <div style={inputContainerStyle}>
              <label>{t('account.dateOfBirth')}</label>
              {!dobManualActive ? (
                <>
                  <DatePicker
                    selected={dob ? new Date(dob) : null}
                    onChange={(date) => {
                      const localDate = date.toLocaleDateString("en-CA");
                      setDob(localDate);
                      console.log("Date of Birth added:", localDate); // <-- Added console log
                      setDobManual("");
                      if (isDobTimeUnknown) setDobTime("00:00");
                      handleFetchData(false);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText={t('signUpPage.selectDate')}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    showPopperArrow={false}
                    maxDate={new Date()}
                    filterDate={(date) => date <= new Date()}
                    style={inputStyle}
                  />
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <button
                      type="button"
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => setDobManualActive(true)}
                    >
                      {t('signUpPage.enterManually')}
                    </button>
                  </div>
                </>
              ) : (
                <div style={{ width: "100%" }}>
                  <input
                    type="text"
                    value={dobManual}
                    onChange={(e) => {
                      setDobManual(e.target.value);
                      const parsed = parseManualDate(e.target.value);
                      if (parsed) {
                        setDob(parsed);
                        console.log("Date of Birth added (manual):", parsed); // <-- Added console log
                        if (isDobTimeUnknown) setDobTime("00:00");
                        handleFetchData(false);
                      }
                    }}
                    placeholder="DD-MM-YYYY"
                    style={{
                      ...inputStyle,
                      color: "#888",
                      backgroundColor: "#111",
                      border: "1px solid #666",
                      outline: "1px solid #666",
                    }}
                    maxLength={10}
                  />
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <button
                      type="button"
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => setDobManualActive(false)}
                    >
                      {t('signUpPage.useDatePicker')}
                    </button>
                  </div>
                </div>
              )}

              {!isDobTimeUnknown && (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select
                    value={dobHour}
                    onChange={(e) => {
                      const val = e.target.value;
                      syncTimeFromDob(val, dobMinute, dobAmPm);
                    }}
                    style={{ width: 120, height: 44, ...DOBstyle }}
                  >
                    <option value="">HH</option>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                      <option key={h} value={h}>
                        {String(h).padStart(2, "0")}
                      </option>
                    ))}
                  </select>
                  <span>:</span>
                  <input
                    type="number"
                    min="0"
                    max="59"
                    value={dobMinute}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      if (
                        val === "" ||
                        (parseInt(val, 10) >= 0 && parseInt(val, 10) <= 59)
                      ) {
                        syncTimeFromDob(dobHour, val, dobAmPm);
                      }
                    }}
                    placeholder="MM"
                    style={{ width: 120, height: 44, ...DOBstyle }}
                  />
                  <select
                    value={dobAmPm}
                    onChange={(e) => {
                      syncTimeFromDob(dobHour, dobMinute, e.target.value);
                    }}
                    style={{ width: 120, height: 44, ...DOBstyleAMPM }}
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              )}
            </div>
            )}

            {birthCalendarMode === "gregorian" && !!chineseDob && (
              <div style={inputContainerStyle}>
                <label>{t('account.chineseDateOfBirth')}</label>
                <input
                  type="text"
                  value={chineseDob ? chineseDob.split("-").reverse().join("-") : ""}
                  placeholder={t('signUpPage.selectDate')}
                  style={readOnlyDOBStyle}
                  readOnly
                  disabled
                />

                {!isDobTimeUnknown && (
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input
                      type="text"
                      value={chineseDobHour ? String(chineseDobHour).padStart(2, "0") : ""}
                      placeholder="HH"
                      style={{ width: 120, height: 44, ...readOnlyDOBStyle }}
                      readOnly
                      disabled
                    />
                    <span>:</span>
                    <input
                      type="text"
                      value={chineseDobMinute ? String(chineseDobMinute).padStart(2, "0") : ""}
                      placeholder="MM"
                      style={{ width: 120, height: 44, ...readOnlyDOBStyle }}
                      readOnly
                      disabled
                    />
                    <input
                      type="text"
                      value={chineseDobTime ? chineseDobAmPm : ""}
                      placeholder="AM/PM"
                      style={{ width: 120, height: 44, ...readOnlyDOBStyle }}
                      readOnly
                      disabled
                    />
                  </div>
                )}
              </div>
            )}

            {birthCalendarMode === "lunar" && (
            <div style={inputContainerStyle}>
              <label>{t('account.chineseDateOfBirth')}</label>
              {!chineseDobManualActive ? (
                <>
                  <DatePicker
                    selected={chineseDob ? new Date(chineseDob) : null}
                    onChange={(date) => {
                      const localDate = date.toLocaleDateString("en-CA");
                      setChineseDob(localDate);
                      console.log("Chinese Date of Birth added:", localDate); // <-- Added console log
                      setChineseDobManual("");
                      if (isDobTimeUnknown) setChineseDobTime("00:00");
                      handleFetchData(true);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText={t('signUpPage.selectDate')}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    showPopperArrow={false}
                    maxDate={new Date()}
                    filterDate={(date) => date <= new Date()}
                    style={inputStyle}
                  />
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <button
                      type="button"
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => setChineseDobManualActive(true)}
                    >
                      {t('signUpPage.enterManually')}
                    </button>
                  </div>
                </>
              ) : (
                <div style={{ width: "100%" }}>
                  <input
                    type="text"
                    value={chineseDobManual}
                    onChange={(e) => {
                      setChineseDobManual(e.target.value);
                      const parsed = parseManualDate(e.target.value);
                      if (parsed) {
                        setChineseDob(parsed);
                        console.log("Chinese Date of Birth added (manual):", parsed); // <-- Added console log
                        if (isDobTimeUnknown) setChineseDobTime("00:00");
                        handleFetchData(true);
                      }
                    }}
                    placeholder="DD-MM-YYYY"
                    style={{
                      ...inputStyle,
                      color: "#888",
                      backgroundColor: "#111",
                      border: "1px solid #666",
                      outline: "1px solid #666",
                    }}
                    maxLength={10}
                  />
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <button
                      type="button"
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => setChineseDobManualActive(false)}
                    >
                      {t('signUpPage.useDatePicker')}
                    </button>
                  </div>
                </div>
              )}

              {!isDobTimeUnknown && (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select
                    value={chineseDobHour}
                    onChange={(e) => {
                      const val = e.target.value;
                      syncTimeFromChinese(val, chineseDobMinute, chineseDobAmPm);
                    }}
                    style={{ width: 120, height: 44, ...DOBstyle }}
                  >
                    <option value="">HH</option>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                      <option key={h} value={h}>
                        {String(h).padStart(2, "0")}
                      </option>
                    ))}
                  </select>
                  <span>:</span>
                  <input
                    type="number"
                    min="0"
                    max="59"
                    value={chineseDobMinute}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      if (
                        val === "" ||
                        (parseInt(val, 10) >= 0 && parseInt(val, 10) <= 59)
                      ) {
                        syncTimeFromChinese(chineseDobHour, val, chineseDobAmPm);
                      }
                    }}
                    placeholder="MM"
                    style={{ width: 120, height: 44, ...DOBstyle }}
                  />
                  <select
                    value={chineseDobAmPm}
                    onChange={(e) => {
                      syncTimeFromChinese(
                        chineseDobHour,
                        chineseDobMinute,
                        e.target.value
                      );
                    }}
                    style={{ width: 120, height: 44, ...DOBstyleAMPM }}
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              )}
            </div>
            )}

            {birthCalendarMode === "lunar" && !!dob && (
              <div style={inputContainerStyle}>
                <label>{t('account.dateOfBirth')}</label>
                <input
                  type="text"
                  value={dob ? dob.split("-").reverse().join("-") : ""}
                  placeholder={t('signUpPage.selectDate')}
                  style={readOnlyDOBStyle}
                  readOnly
                  disabled
                />

                {!isDobTimeUnknown && (
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input
                      type="text"
                      value={dobHour ? String(dobHour).padStart(2, "0") : ""}
                      placeholder="HH"
                      style={{ width: 120, height: 44, ...readOnlyDOBStyle }}
                      readOnly
                      disabled
                    />
                    <span>:</span>
                    <input
                      type="text"
                      value={dobMinute ? String(dobMinute).padStart(2, "0") : ""}
                      placeholder="MM"
                      style={{ width: 120, height: 44, ...readOnlyDOBStyle }}
                      readOnly
                      disabled
                    />
                    <input
                      type="text"
                      value={dobTime ? dobAmPm : ""}
                      placeholder="AM/PM"
                      style={{ width: 120, height: 44, ...readOnlyDOBStyle }}
                      readOnly
                      disabled
                    />
                  </div>
                )}
              </div>
            )}

            {age !== "" && (
              <div style={{ marginTop: 4 }}>
                <p>{t('signUpPage.yourAge')}: {age}</p>
              </div>
            )}

            <div
              style={{
                ...inputContainerStyle,
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <input
                id="dobTimeUnknown"
                type="checkbox"
                checked={isDobTimeUnknown}
                onChange={() => {
                  setIsDobTimeUnknown(!isDobTimeUnknown);
                  if (!isDobTimeUnknown) {
                    setDobTime("00:00");
                    setChineseDobTime("00:00");
                  }
                }}
                style={checkboxStyle}
              />
              <label htmlFor="dobTimeUnknown" style={checkboxLabelStyle}>
                {t('signUpPage.dontKnowTime')}
              </label>
            </div>
          </div>
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionHeaderStyle}>{t('signUpPage.contact')}</h3>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              const newEmail = e.target.value;
              setEmail(newEmail);
              // Clear format error while typing; validate on blur instead
              if (emailFormatError) setEmailFormatError("");
              // Clear server-existence message while editing
              if (emailExists) {
                setEmailExists(false);
                setEmailExistsMessage("");
              }
            }}
            onBlur={async () => {
              // Validate on blur (when user leaves the field)
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (email.trim().length > 0 && !emailRegex.test(email)) {
                setEmailFormatError(t('signUpPage.invalidEmail') || 'Please enter a valid email address');
                setEmailExists(false);
                setEmailExistsMessage("");
                return;
              } else {
                setEmailFormatError("");
              }

              // Only check server-side existence when format is valid
              if (email.includes("@")) {
                try {
                  const res = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/user/IsEmailExist?email=${encodeURIComponent(email)}`
                  );
                  const data = await res.json();
                  if (data.successful === true) {
                    setEmailExists(true);
                    setEmailExistsMessage(data.Message || t('signUpPage.emailAlreadyRegistered'));
                  } else {
                    setEmailExists(false);
                    setEmailExistsMessage("");
                  }
                } catch (err) {
                  console.error("Error checking email:", err);
                  setEmailExists(false);
                  setEmailExistsMessage("");
                }
              }
            }}
            placeholder={t('account.email')}
            style={{ ...inputStyle, width: "100%" }}
          />
          {emailFormatError && (
            <p style={{ color: "red", marginTop: "5px" }}>
              {emailFormatError}
            </p>
          )}
          {!emailFormatError && emailExists && (
            <p style={{ color: "white", marginTop: "5px" }}>
              {emailExistsMessage || t('signUpPage.emailAlreadyRegistered')}
            </p>
          )}

          <div style={{ display: "flex", gap: 12, marginTop: 12, flexWrap: "wrap" }}>
            <input
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              placeholder={t('signUpPage.referralCode')}
              style={{
                ...inputStyle,
                flex: 1,
                minWidth: 240,
                backgroundColor: !!promocode ? "#222" : inputStyle.backgroundColor,
                color: !!promocode ? "#888" : inputStyle.color,
                cursor: !!promocode ? "not-allowed" : "auto"
              }}
              disabled={!!promocode}
            />
          </div>

          <div style={{ display: "flex", gap: 12, marginTop: 12, flexWrap: "wrap", alignItems: "center" }}>
            <select
              value={selectedKey}
              onChange={(e) => {
                const key = e.target.value;
                if (!key) {
                  setCountry(null);
                  setCountryCode("");
                  return;
                }
                const found = countries.find(
                  (c) => (c.ISO2 || c.iso2) === key || String(c.ID) === key || c.DESC_ENG === key || c.country === key
                );
                if (found) {
                  const obj = {
                    country: found.DESC_ENG || found.country,
                    dial_code: found.dial_code || found.Dial_Code || "",
                    iso2: found.ISO2 || found.iso2,
                    iso3: found.ISO3 || found.iso3,
                    ID: found.ID,
                  };
                  setCountry(obj);
                  if (obj.dial_code) setCountryCode(obj.dial_code);
                } else {
                  setCountry(key);
                }
              }}
              style={{ ...inputStyleCountries, flex: 1, minWidth: 240 }}
            >
              <option value="" disabled hidden>{t('signUpPage.selectCountry')}</option>
              {countries.map((c) => (
                <option key={c.ID || c.iso2 || c.country} value={c.ISO2 || c.iso2 || c.ID || c.DESC_ENG || c.country}>
                  {c.DESC_ENG || c.country} ({c.dial_code || c.Dial_Code || ""})
                </option>
              ))}
            </select>
            <input
              type="text"
              value={mobile}
              onChange={async (e) => {
                const newMobile = e.target.value;
                setMobile(newMobile);

                let formatResult = { valid: true, errorMsg: "" };
                if (countryCode && newMobile.trim().length > 0) {
                  formatResult = validateMobileByCountry(newMobile, countryCode);
                  setMobileFormatError(formatResult.errorMsg);
                } else {
                  setMobileFormatError("");
                }

                if (newMobile.trim().length > 0 && countryCode && formatResult.valid) {
                  const formattedMobile = `${countryCode} ${newMobile}`;
                  try {
                    const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/user/IsMobileExist?mobile=${encodeURIComponent(formattedMobile)}`;
                    const res = await fetch(apiUrl);
                    const data = await res.json();
                    if (data.successful === true) {
                      setMobileExists(true);
                      setMobileExistsMessage(data.Message || t('signUpPage.mobileAlreadyUsed'));
                    } else {
                      setMobileExists(false);
                      setMobileExistsMessage("");
                    }
                  } catch (err) {
                    setMobileExists(false);
                    setMobileExistsMessage("");
                  }
                } else {
                  setMobileExists(false);
                  setMobileExistsMessage("");
                }
              }}
              placeholder={t('account.mobileNumber')}
              style={{ ...inputStyle, flex: 1, minWidth: 240 }}
            />

            {mobileFormatError && (
              <p style={{ color: "red", marginTop: "5px" }}>
                {mobileFormatError}
              </p>
            )}
            {mobileExists && !mobileFormatError && (
              <p style={{ color: "white", marginTop: "5px" }}>
                {mobileExistsMessage || t('signUpPage.mobileAlreadyRegistered')}
              </p>
            )}
          </div>
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionHeaderStyle}>{t('signUpPage.interests')}</h3>
          {interestOptions.map(option => (
            <div key={option.Uid} style={{ marginTop: 8 }}>
              <label>
                <input
                  type="checkbox"
                  value={option.Uid}
                  checked={selectedInterestUids.includes(option.Uid)}
                  onChange={() => handleInterestChange(option.Uid, option.Description)}
                />
                <span
                  style={{
                    marginLeft: 8,
                    backgroundColor: selectedInterestUids.includes(option.Uid) ? "#DFBD69" : "transparent",
                    color: selectedInterestUids.includes(option.Uid) ? "black" : "#DFBD69",
                    padding: selectedInterestUids.includes(option.Uid) ? "2px 8px" : undefined,
                    borderRadius: selectedInterestUids.includes(option.Uid) ? "12px" : undefined,
                  }}
                >
                  {option.Description}
                </span>
              </label>
            </div>
          ))}
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionHeaderStyle}>{t('signUpPage.security')}</h3>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <div style={{ ...passwordInputContainerStyle, flex: 1, minWidth: 240 }}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('loginPage.password')}
                style={{ ...inputStyle, width: "100%" }}
              />
              <span style={eyeIconStyle} onClick={() => setShowPassword((prev) => !prev)}>
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </span>
            </div>
            <div style={{ ...passwordInputContainerStyle, flex: 1, minWidth: 240 }}>
              <input
                type={showRePassword ? "text" : "password"}
                value={rePassword}
                onChange={(e) => setRePassword(e.target.value)}
                placeholder={t('signUpPage.confirmPassword')}
                style={{ ...inputStyle, width: "100%" }}
              />
              <span style={eyeIconStyle} onClick={() => setShowRePassword((prev) => !prev)}>
                {showRePassword ? "👁️" : "👁️‍🗨️"}
              </span>
            </div>
          </div>
          {rePassword && (
            <p style={{ color: isPasswordMatch ? "green" : "red", marginTop: 8 }}>
              {isPasswordMatch ? t('loginPage.passwordMatch') : t('loginPage.passwordNotMatch')}
            </p>
          )}
          {password && !isValidPassword(password) && (
            <p style={{ color: "white", marginTop: 4 }}>
              {t('signUpPage.passwordRequirements')}
            </p>
          )}
        </div>

        <div style={{ ...sectionStyle, display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              id="termsCheckbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              style={{ marginRight: 10 }}
            />
            <label htmlFor="termsCheckbox" style={{ margin: 0 }}>
              {t('signUpPage.agreeToTerms')}
            </label>
            <span
              onClick={openModal}
              style={{
                color: "#DFBD69",
                textDecoration: "underline",
                cursor: "pointer",
                marginLeft: 5,
              }}
              tabIndex={0}
              role="button"
              aria-label="View Terms and Conditions"
              onKeyPress={e => { if (e.key === "Enter" || e.key === " ") openModal(); }}
            >
              {t('footer.termsConditions')}
            </span>
          </div>

          {isModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                className="terms-modal-content"
                style={{
                  backgroundColor: "#151517",
                  padding: 20,
                  borderRadius: 8,
                  width: "80%",
                  maxWidth: 600,
                  textAlign: "left",
                  maxHeight: "80vh",
                  overflowY: "auto",
                }}
              >
                <TermsAndConditions />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 16,
                    marginTop: 20,
                  }}
                >
                  <button
                    onClick={() => {
                      setIsChecked(true);
                      closeModal();
                    }}
                    style={{
                      padding: "10px 20px",
                      fontSize: 16,
                      backgroundColor: "#DFBD69",
                      color: "black",
                      border: "none",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    {t('courses.accept')}
                  </button>
                  <button
                    onClick={closeModal}
                    style={{
                      padding: "10px 20px",
                      fontSize: 16,
                      backgroundColor: "#222",
                      color: "#DFBD69",
                      border: "1px solid #DFBD69",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    {t('loginPage.close')}
                  </button>
                </div>
              </div>
            </div>
          )}

          <div>
            <button
              onClick={handleConfirm}
              style={isCreatingAccount ? disabledButtonStyle : buttonStyle}
              disabled={isCreatingAccount}
            >
              {isCreatingAccount ? t('signUpPage.creatingAccount') : t('signUpPage.createAccountButton')}
            </button>
          </div>

          {showErrorModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "#151517",
                  padding: 20,
                  borderRadius: 8,
                  width: "80%",
                  maxWidth: 480,
                  textAlign: "left",
                }}
              >
                <h3 style={{ color: "#DFBD69", marginTop: 0 }}>{t('signUpPage.pleaseComplete')}</h3>
                <ul style={{ color: "#fff", paddingLeft: 20 }}>
                  {errorModalIssues.map((issue, idx) => (
                    <li key={idx} style={{ marginBottom: 6 }}>{issue}</li>
                  ))}
                </ul>
                <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
                  <button
                    onClick={() => setShowErrorModal(false)}
                    style={{
                      padding: "10px 20px",
                      fontSize: 16,
                      backgroundColor: "#DFBD69",
                      color: "black",
                      border: "none",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    {t('loginPage.close')}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default SignUpPage;